import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { Menu } from '@modules/security/profile/models/menu';
import { Profile, ProfileApi, ProfileMenu, ProfileMenuId } from '@modules/security/profile/models/profile';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ProfileService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/profiles';
	}

	public getAllProfileByRoleId(roleId: string) {
		return this._restClientService
			.get(this.apiUrl + '/roles/' + roleId)
			.pipe(map((result: any[]) => result.filter((i) => i.valid)));
	}

	public getProfileApiList(profileId: string): Observable<any[]> {
		return this._restClientService.post(`${this.apiUrl}/${profileId}/apis/vw/list`, '{}');
	}
}

@Injectable()
export class ProfileMenuService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/profiles';
	}

	private PROFILE_API: string = Urls.BASE_URL.toString() + '/sec/profiles';

	public getMenuProfilePaginationByProfileId(
		id: string,
		pageNumber: number,
		pageInSize: number,
		sort: any,
		searchObject: Profile
	): Observable<any> {
		const url =
			this.PROFILE_API + '/' + id + '/apis/vw/' + '/page?page=' + pageNumber + '&size=' + pageInSize + '&sort=' + sort;
		return this._restClientService.post(url, JSON.stringify(searchObject));
	}

	public getAllMenuByProfileList(profiles: Array<string>): Observable<Menu[]> {
		return this._restClientService.get(this.PROFILE_API + '/' + profiles + '/menus');
	}

	public getAllMenuByProfile(profile: Profile): Observable<Menu[]> {
		return this._restClientService.get(`${this.PROFILE_API}/${profile.id}/menus`);
	}

	public createProfileMenu(profileMenu: ProfileMenuId): Observable<ProfileMenu> {
		return this._restClientService.post(
			this.PROFILE_API + '/' + profileMenu.profileId + '/menus',
			JSON.stringify(profileMenu)
		);
	}

	public createProfileMenus(profileId: string, profileMenus): Observable<any> {
		return this._restClientService
			.post(this.PROFILE_API + '/' + profileId + '/menus', JSON.stringify(profileMenus))
			.pipe(catchError(this.handleError));
	}

	public updateProfile(profile: Profile): Observable<Profile> {
		return this._restClientService.put(this.PROFILE_API + '/' + profile.id, JSON.stringify(profile));
	}

	public deleteAProfileMenu(profileMenu: ProfileMenu): Observable<void> {
		return this._restClientService
			.delete(this.PROFILE_API + '/' + profileMenu.profileId + '/menus/' + profileMenu.menuId)
			.pipe(catchError(this.handleError));
	}

	public deleteProfileMenu(profileId: string, menuId: string): Observable<void> {
		return this._restClientService
			.delete(this.PROFILE_API + '/' + profileId + '/menus/' + menuId)
			.pipe(catchError(this.handleError));
	}
}

@Injectable()
export class ProfileApiService extends OldLegacyBaseApiService<any> {
	private PROFILE_API: string = Urls.BASE_URL.toString() + '/sec/profiles';

	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/profiles';
	}

	public getApiPaginationByProfileId(
		id: string,
		pageNumber: number,
		pageInSize: number,
		sort: any,
		searchObject: Profile
	): Observable<any> {
		const url =
			this.PROFILE_API + '/' + id + '/apis' + '/page?page=' + pageNumber + '&size=' + pageInSize + '&sort=' + sort;
		return this._restClientService.post(url, JSON.stringify(searchObject));
	}

	public getAllApiByProfileList(profiles?: Array<string>, profile?: string): Observable<ProfileApi[]> {
		return this._restClientService.get(this.PROFILE_API + '/' + profile + profiles + '/apis');
	}

	public getAllApiByProfile(profile: Profile): Observable<ProfileApi[]> {
		return this._restClientService.get(`${this.PROFILE_API}/${profile.id}/apis`);
	}

	public createProfileApi(profileId: string, profileApis): Observable<any> {
		return this._restClientService
			.post(this.PROFILE_API + '/' + profileId + '/apis', JSON.stringify(profileApis))
			.pipe(catchError(this.handleError));
	}

	public deleteProfileApi(profileId: string, apiId: string): Observable<void> {
		return this._restClientService
			.delete(this.PROFILE_API + '/' + profileId + '/apis/' + apiId)
			.pipe(catchError(this.handleError));
	}
}
